import React from 'react';
import { connect } from 'react-redux';
import "./ImageTagV2.css";
import { injectIntl } from 'react-intl'
import ImageIconDart from "../../../assets/icons/image_dart.svg";
import classNames from 'classnames'

class ImageTagV2 extends React.Component {
  constructor(props) {
    super(props)
    this.state = {}
  }
  onClickHandler = () => {
    const { onClick, versionNumber, imagePoint, intl } = this.props
    if (onClick) {
      console.log('Hizo click en el tag image');
      onClick(versionNumber, imagePoint.index, imagePoint.pointX, imagePoint.pointY, intl)
    }
  }
  render() {
      const {
          versionNumber,
          imagePoint,
          onClick
      } = this.props;
      var classes = classNames({
        'imageFile': true,
        'cursor-pointer': (onClick) ? true : false,
      });
      return (
          <React.Fragment>
            <p className={classes} onClick={this.onClickHandler}>
              <img src={ImageIconDart} alt="img" className='image-tag-icon' />
              num. {imagePoint.index} v.{versionNumber}
            </p>
          </React.Fragment>
      )
  }

}

const mapStateToProps = (state, ownProps) => {
  return {}
}

const mapDispatchToProps = {
}

export default injectIntl(connect(mapStateToProps, mapDispatchToProps)(ImageTagV2))
